import styled from "styled-components";
import { Header } from "components/header";
import { Motto } from "components/motto";
import { VisibilityAnimator } from "components/visibilityAnimator";
import { Footer } from "components/footer";
import { constants } from "constants";
import { BackgroundRunners } from "components/backgroundRunners";
import { Body } from "components/body";
import { TopScroller } from "components/topScroller";

const StyledApp = styled.div`
  position: relative;
  background-color: #0b131d;
  padding-top: ${constants.headerHeight}px;
`;

const StyledBody = styled.div`
  position: relative;
  z-index: 1;
  padding-inline: var(--page-gutter);
  overflow: hidden;
`;

export const LoadedApp = () => {
  return (
    <StyledApp>
      <BackgroundRunners />
      <Header />
      <StyledBody>
        <VisibilityAnimator nonRelative showInstantly>
          <Motto />
        </VisibilityAnimator>
        <Body />
      </StyledBody>
      <TopScroller />
      <VisibilityAnimator zIndex={0}>
        <Footer />
      </VisibilityAnimator>
    </StyledApp>
  );
};
